module.exports = __webpack_public_path__ + "static/media/record-silver.b304ff41.png";